import {Box, Grid} from '@primer/react-brand/esm'
import baseStyles from '../../styles/base.module.css'
import type {IconLinkItem} from '../../types'
import {IconStoryCard} from './IconStoryCard'

export function IconCards({stories}: {stories: IconLinkItem[]}) {
  return (
    <Box className={`${baseStyles.gridFrameTop} ${baseStyles.gridFrameBottom}`}>
      <Grid columnGap="none" rowGap="none" enableGutters={false}>
        <Grid.Column span={{xsmall: 12, medium: 10, xlarge: 12}} start={{medium: 2}}>
          <Grid columnGap="none" rowGap="none" enableGutters={false} className={baseStyles.narrowStackFrame}>
            {stories.map(story => (
              <Grid.Column
                key={story.sys.id}
                span={{xsmall: 12, xlarge: 4}}
                // eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals
                className="gridColumn"
              >
                <IconStoryCard story={story} />
              </Grid.Column>
            ))}
          </Grid>
        </Grid.Column>
      </Grid>
    </Box>
  )
}
